import type { PropsWithChildren } from 'react';

export function Circle(props: Readonly<PropsWithChildren>) {
	return <span className="circle circle--red">{props.children}</span>;
}
